import { render, staticRenderFns } from "./CarrierSelectedTendering.vue?vue&type=template&id=5532052e&scoped=true"
import script from "./CarrierSelectedTendering.vue?vue&type=script&lang=js"
export * from "./CarrierSelectedTendering.vue?vue&type=script&lang=js"
import style0 from "./CarrierSelectedTendering.vue?vue&type=style&index=0&id=5532052e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5532052e",
  null
  
)

export default component.exports